import React from 'react'
import ReactApexChart from 'react-apexcharts'

export default class NewCustomer extends React.Component {
  render() {
    return (
      <div id='chart'>
        <ReactApexChart options={this.props.options} series={this.props.series} type='radialBar' />
      </div>
    )
  }
}
